'use client';

import React from 'react';
import Link from 'next/link';
import GoogleTranslateWidget from '@/components/GoogleTranslateWidget';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import AppLogo, { APP_LOGO_HEIGHT } from '@/components/ui/AppLogo';

type Props = {
  logoHref?: string;
  logoSrc?: string;
  /** Hauteur du logo en px (défaut : taille compacte nav). */
  logoSize?: number;
  rightSlot?: React.ReactNode;
  /** Désactivé sur le paiement : Google Translate casse le DOM des modales sur mobile. */
  showTranslate?: boolean;
};

export default function PublicFlowHeader({
  logoHref = '/sign-up-login-screen',
  logoSrc = '/assets/images/logo_rose.png',
  logoSize = APP_LOGO_HEIGHT,
  rightSlot,
  showTranslate = true,
}: Props) {
  return (
    <>
      {showTranslate && <GoogleTranslateWidget />}
      <header
        className="sticky top-0 z-30 w-full"
        style={{
          backgroundColor: '#FAF8F6',
          borderBottom: '1px solid #E8E4DF',
          boxShadow: '0 2px 12px rgba(31,29,64,0.06)',
        }}
      >
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-3 h-12">
          <Link href={logoHref} className="flex items-center gap-2 shrink-0">
            <AppLogo src={logoSrc} size={logoSize} />
          </Link>

          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            {rightSlot}
            <div className="hidden lg:block">
              <LanguageSwitcher variant="desktop" />
            </div>
            <div className="lg:hidden">
              <LanguageSwitcher variant="mobile" />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
